import React from 'react';
import { Table, TableHeader, TableColumn, TableBody, TableRow, TableCell } from "@nextui-org/react";

/**
 * HayaTableRender Component
 * Renders markdown tables as interactive NextUI tables
 * Converts markdown table format to structured table components
 * @param {Object} props - Component props
 * @param {Array<string>} props.markdownTable - Array of markdown table rows
 * @returns {JSX.Element} Rendered table component
 */
const HayaTableRender = ({ markdownTable }) => {
    // Replace escape sequences (like \n for new lines) with HTML breaks
    const formattedTable = markdownTable.map(row => row.replace(/\\n/g, '<br/>'));

    // Extract header and data rows from the formatted table
    const [headerRow, ...dataRows] = formattedTable.map(row => 
        row.split('|').map(cell => cell.trim())
    );

    return (
        <div className="mt-4">
            <Table removeWrapper aria-label="Markdown table">
                {/* Table Header */}
                <TableHeader>
                    {headerRow.map((cell, index) => (
                        <TableColumn key={`header-${index}`}>
                            {cell}
                        </TableColumn>
                    ))}
                </TableHeader>
                
                {/* Table Body */}
                <TableBody>
                    {dataRows
                        .filter(row => row.length === headerRow.length) // Filter rows where length matches header
                        .map((row, rowIndex) => (
                            <TableRow key={`row-${rowIndex}`}>
                                {row.map((cell, cellIndex) => (
                                    <TableCell key={`cell-${rowIndex}-${cellIndex}`}>
                                        {/* Render the content, handle HTML tags like <br/> */}
                                        <span dangerouslySetInnerHTML={{ __html: cell }} />
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </div>
    );
};

export default HayaTableRender;
